import QmExport from './src/main'

/* istanbul ignore next */
QmExport.install = function (Vue) {
  Vue.component(QmExport.name, QmExport)
}

export default QmExport
